// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"17a0f0b0","557":"1dad74a2","617":"7d8e2a00","705":"c6470975","763":"543086c0"}[chunkId] + ".chunk.css";
};